import React from 'react';
import {
    AddressLocation,
    AddressLocationFontSize,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
} from '../AddressLocation';

export const AddressLocationDemo: React.FC = () => {
    return (
        <div style={{ maxWidth: '500px' }}>
            <div style={{ marginTop: '0px', marginBottom: '20px' }}>
                <h2>Address Location :</h2>
                <br />
                <br />
                Address with no property indicator:
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                />
                Address with property indicator:
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    propertyNumber={3}
                />
                <br />
                <br />
                <b>
                    <u>Regular Style</u>
                </b>
                <br />
                <br />
                Address with no property indicator (<b>blue</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                />
                Address with no property indicator (<b>black</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Black}
                />
                Address with no property indicator (<b>gray</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Gray}
                />
                Address with no property indicator (<b>red</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Red}
                />
                <br />
                <br />
                <b>
                    <u>Bold Style</u>
                </b>
                <br />
                <br />
                Address with no property indicator (<b>blue</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    line1Style={AddressLocationLine1Style.Bold}
                />
                Address with no property indicator (<b>black</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Black}
                    line1Style={AddressLocationLine1Style.Bold}
                />
                Address with no property indicator (<b>gray</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Gray}
                    line1Style={AddressLocationLine1Style.Bold}
                />
                Address with no property indicator (<b>red</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St'
                    addressLine2='Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Red}
                    line1Style={AddressLocationLine1Style.Bold}
                />
                <br />
                <br />
                <b>
                    <u>Single Line (bold style / smaller fonts)</u>
                </b>
                <br />
                <br />
                Address with no property indicator (<b>blue</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St, Testville IN 34872'
                    line1Style={AddressLocationLine1Style.Bold}
                    fontSize={AddressLocationFontSize.Smaller}
                />
                Address with no property indicator (<b>black</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St, Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Black}
                    line1Style={AddressLocationLine1Style.Bold}
                    fontSize={AddressLocationFontSize.Smaller}
                />
                Address with no property indicator (<b>gray</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St, Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Gray}
                    line1Style={AddressLocationLine1Style.Bold}
                    fontSize={AddressLocationFontSize.Smaller}
                />
                Address with no property indicator (<b>red</b> indicator):
                <AddressLocation
                    addressLine1='33 Browning St, Testville IN 34872'
                    indicatorStyle={AddressLocationIndicatorStyle.Red}
                    line1Style={AddressLocationLine1Style.Bold}
                    fontSize={AddressLocationFontSize.Smaller}
                />
            </div>
        </div>
    );
};
